import { Analytics } from '@cobliteam/analytics';
import { Button, Popover, Typography } from '@cobliteam/ui/components';

import Switch from '@cobliteam/ui/components/Switch';
import Icon from '@cobliteam/ui/icons';

interface MapMatchProps {
  mapMatchActive: boolean;
  handleToggleMapMatch: () => void;
}

const MapMatch = ({ mapMatchActive, handleToggleMapMatch }: MapMatchProps) => {
  const handleCtaMapMatchClick = () => {
    Analytics.track('Know More About Map Match Clicked', {
      origin: 'tracking page toggle tooltip map match',
    });

    window.open('https://suporte.cobli.co/como-funciona-a-configura%C3%A7%C3%A3o-de-ajus?hs_preview=ZtAODARM-118192092066');
  };

  return (
    <div className='flex items-center gap-2'>
      <Switch size='sm' name='MapMatchSwitch' onCheckedChange={handleToggleMapMatch} checked={mapMatchActive} />
      <div className='flex items-center gap-2'>
        <Typography variant='caption-default'>Ajuste de trajetos</Typography>

        <Popover>
          <Popover.Trigger>
            <Icon name='circle-help' color='gray' />
          </Popover.Trigger>

          <Popover.Content className='z-[1000] flex w-72 flex-col gap-2.5'>
            <Typography variant='description-title'>Ajuste de trajetos</Typography>
            <Typography variant='body'>
              Melhora a visualização dos trajetos próximos às vias do mapa. Desativar pode ajudar em análises de eventos fora das vias, em indústrias, fazendas e estacionamentos.
            </Typography>
            <Button variant='link' size='sm' onClick={handleCtaMapMatchClick}>
              Entenda como funciona
            </Button>
          </Popover.Content>
        </Popover>
      </div>
    </div>
  );
};

export default MapMatch;
